import UserBrand from "./UserBrand-container";

/**
 * Export the top level component UserBrand-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default UserBrand;
